import { createStore } from 'vuex'
import * as youtube from './modules/youtube'
import * as youtubeTranscript from './modules/youtubeTranscript'
import * as smEnricher from './modules/sm_enricher'
import * as signal from './modules/validTargets'
import * as instantTracker from './modules/intentTracker'
import * as youtubeLight from './modules/youtube_light'
import * as magicClips from './modules/magicClips'
import * as hostsGuests from './modules/hostsGuests'
import * as useCases from './modules/useCases'
import * as competitors from './modules/competitors'
import * as coWorkers from './modules/coWorkers'
import * as apolloEndpoints from './modules/apolloEndpoints'
import * as icp from './modules/icp'
import * as serpQuery from './modules/serpQuery'
import * as reddit from './modules/reddit'
import * as scriptGenerator from './modules/scriptGenerator'
import * as ayeletEmails from "./modules/ayeletEmails";
import * as personalizedEmails from "./modules/personalizedEmails";
import * as personalizedEmailsV2 from "./modules/personalizedEmailsV2";
import * as personalizedEmailsV3 from "./modules/personalizedEmailsV3";
import * as personalizedEmailsChurn from "./modules/personalizedEmailsChurn";
import * as winBackV1 from "./modules/winBackV1";
import * as winBackV2 from "./modules/winBackV2";
import * as winBackV3 from "./modules/winBackV3";
import * as youtubeThumbnail from "./modules/youtubeThumbnail";
import * as coverArtGenerator from "./modules/coverArtGenerator";
import * as podcastCharts from "./modules/podcastCharts";
import * as auth from "./modules/auth";
import {validateEmail} from "./utils";

export default createStore({
  state: {
    isModal: false,
    sseEventMsg: {msg: ''},
    reqStatus: 'idle',
    emailToSendCSV: localStorage.getItem('emailToSendCSV')
  },
  mutations: {
    SET_MODAL (state, value) {
      state.isModal = value;
    },
    SSE_EVENT (state, msg) {
      state.sseEventMsg = JSON.parse(msg)
    },
    SET_EMAIL (state, value) {
      state.emailToSendCSV = value
      validateEmail(value) && localStorage.setItem('emailToSendCSV', value)
    },
    SET_REQ_STATUS(state, status) {
      if (status === 'success') {
        state.reqStatus = 'success'
        setTimeout(() => {
          state.reqStatus = 'idle'
        }, 1000)
      } else {
        state.reqStatus = status
      }
    },
    SET_LOCAL_STORAGE (state, {name, value}) {
      localStorage.setItem(name, value)
    }
  },
  actions: {},
  modules: {
    youtube,
    youtubeLight,
    youtubeTranscript,
    smEnricher,
    signal,
    instantTracker,
    magicClips,
    hostsGuests,
    useCases,
    competitors,
    coWorkers,
    apolloEndpoints,
    icp,
    serpQuery,
    ayeletEmails,
    personalizedEmails,
    personalizedEmailsV2,
    personalizedEmailsV3,
    personalizedEmailsChurn,
    winBackV1,
    winBackV2,
    winBackV3,
    reddit,
    scriptGenerator,
    youtubeThumbnail,
    coverArtGenerator,
    podcastCharts,
    auth,
  }
})
